import type { ReactNode } from 'react'
import { Link } from 'react-router'
import { IconChevronRight } from './icons.tsx'

interface SectionProps {
  title?: ReactNode
  count?: number
  aside?: ReactNode
  footer?: ReactNode
  tone?: 'default' | 'attn'
  padded?: boolean
  children: ReactNode
  id?: string
}

export function Section({
  title,
  count,
  aside,
  footer,
  tone = 'default',
  padded,
  children,
  id,
}: SectionProps) {
  const headerId = id ? `${id}-title` : undefined
  return (
    <section className="section" aria-labelledby={headerId}>
      {(title || aside) && (
        <div className={`section__header${tone === 'attn' ? ' section__header--attn' : ''}`}>
          <h2 id={headerId} className="section__title">
            {title}
            {count !== undefined && <span className="section__count"> · {count}</span>}
          </h2>
          {aside}
        </div>
      )}
      <div className={`section__body${padded ? ' section__body--padded' : ''}`}>{children}</div>
      {footer && <div className="section__footer">{footer}</div>}
    </section>
  )
}

interface CellProps {
  title: ReactNode
  subtitle?: ReactNode
  before?: ReactNode
  after?: ReactNode
  /** Показать шеврон (переход). */
  chevron?: boolean
  danger?: boolean
  to?: string
  onClick?: () => void
  disabled?: boolean
  ariaLabel?: string
}

export function Cell({
  title,
  subtitle,
  before,
  after,
  chevron,
  danger,
  to,
  onClick,
  disabled,
  ariaLabel,
}: CellProps) {
  const cls = `cell${danger ? ' cell--danger' : ''}`
  const content = (
    <>
      {before && <span className="cell__before">{before}</span>}
      <span className="cell__main">
        <span className="cell__title">{title}</span>
        {subtitle && <span className="cell__subtitle">{subtitle}</span>}
      </span>
      {(after || chevron) && (
        <span className="cell__after">
          {after}
          {chevron && <IconChevronRight size={18} className="chevron" />}
        </span>
      )}
    </>
  )
  if (to) {
    return (
      <Link to={to} className={cls} aria-label={ariaLabel}>
        {content}
      </Link>
    )
  }
  if (onClick) {
    return (
      <button type="button" className={cls} onClick={onClick} disabled={disabled} aria-label={ariaLabel}>
        {content}
      </button>
    )
  }
  return <div className={cls}>{content}</div>
}
